<template>
  <div
    :id="id ?? undefined"
    class="inline-block"
    :class="{ 'pointer-events-none': disabled }"
  >
    <div :class="{ 'crypkit-button-group': split }">
      <Button
        v-if="split"
        :id="id ? `${id}-main-btn` : undefined"
        :disabled="disabled"
        :loading="loading"
        :type="type"
        :size="size"
        :icon="icon"
      >
        {{ label }}
      </Button>
      <Button
        :id="id ? `${id}-toggle-btn` : undefined"
        :class="{
          'w-control !min-w-auto': split,
          'cursor-default pointer-events-none': split && loading,
        }"
        :loading="loading && !split"
        :disabled="disabled"
        :type="type"
        :size="size"
        :icon="icon"
        :only-icon="onlyIcon"
        @click.stop="toggle"
      >
        <template v-if="!split">
          {{ label }}
        </template>
        <SvgIcon
          icon="ArrowDown"
          class="!mr-0 transition"
          :class="{ 'rotate-180': opened, 'ml-4': !split }"
        />
      </Button>

      <Menu
        :id="id ? `${id}-menu` : undefined"
        v-model="opened"
        :max-height="maxHeight"
      >
        <slot />
      </Menu>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import Button from '@/components/controls/Button'
import Menu from '@/components/misc/Menu'
import SvgIcon from '@/components/misc/SvgIcon'
import type { ButtonSize, ButtonType } from '@/types/components/button'

export default defineComponent({
  components: {
    Button,
    Menu,
    SvgIcon,
  },

  props: {
    id: {
      type: String as PropType<string | null>,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    split: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: null,
    },
    type: {
      type: String as PropType<ButtonType>,
      default: 'primary',
    },
    icon: {
      type: String,
    },
    onlyIcon: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: [String, Number] as PropType<'auto' | number>,
      default: undefined,
    },
  },

  data() {
    return {
      opened: false,
    }
  },

  methods: {
    toggle() {
      if (!this.loading) {
        this.opened = !this.opened
      }
    },
  },
})
</script>
